<template>
  <v-footer
    v-if="isHome"
    dark
    height="auto"
    class="justify-center pl-0"
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="primary">
        <strong class="subheading">お問い合わせはTwitterまで</strong>
        <v-spacer />
        <v-btn
          dark
          icon
          href="https://twitter.com/kontotto591"
        >
          <v-icon>
            mdi-twitter
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-actions class="justify-center">
        &copy;2019 — <strong>脱出メイト</strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data: function() {
    return {
      isHome: false
    }
  },
  watch: {
    '$route' (to, from) {
      this.isHome = to.name === 'top'
    }
  },
  mounted: function(){
    this.isHome = this.$route.name === 'top'
  }
}
</script>
